import { HttpClient } from '../http-client';
import { Role } from './types';

export class RoleAPIClient extends HttpClient {
  public async getAllRoles(): Promise<Role[]> {
    return this.get<Role[]>('/roles');
  }
}
